
<ng-container>
  <div class="desktop-menu">
    <!-- Home Button -->
    <div
      class="l-story-flow-timeline__item mx-1"
      *ngIf="showHomeButton"
      (click)="home()"
      aria-label="Home"
      role="button"
    >
      <div *ngIf="isCreating" class="lds-ring" aria-hidden="true">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <!-- Story Flow Items -->
    <div
      class="l-story-flow-timeline__item mx-1"
      [attr.tabindex]="(i+7)"
      *ngFor="let item of storyflowMenu; let i = index; let isFirst = first"
      [ngClass]="{ 'show': showHoverFirstStep && isFirst, 'error': item.valid === false }"
      (click)="active($event, item.id)"
      (keydown.enter)="active($event, item.id)"
      [attr.aria-label]="item.title"
      role="button"
    >
      <div *ngIf="isCreating" class="lds-ring" aria-hidden="true">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div
        *ngIf="item.id != 16"
        class="l-story-flow-timeline__icon"
        (mouseover)="stepHovered(item)"
        (mouseleave)="stepHovered()"
        [ngStyle]="{
          'color': item.color,
          'background-color': isCompleted(item) || stepHoveredId == item.id ? item.color : '#fff'
        }"
      >
        <svg
          role="img"
          [ngStyle]="{
            'color': isCompleted(item) || stepHoveredId == item.id ? '#fff' : item.color
          }"
          [attr.aria-label]="item.title"
        >
          <use attr.xlink:href="{{item.icon}}"></use>
        </svg>
      </div>
      <div
        *ngIf="item.id != 16"
        class="l-story-flow-timeline__label d-none d-md-block"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</ng-container>

<!-- Mobile Menu -->
<ng-container
  *ngIf="isMediaIncluded && storyflowMenu && storyflowMenu.length && mediaIndex != -1"
>
  <div
    class="media l-story-flow-timeline mobile-menu"
    [ngStyle]="{ 'flex-wrap': showHomeButton ? 'initial' : 'wrap' }"
    style="justify-content: center; margin: 1rem;"
  >
    <!-- Home Button -->
    <div *ngIf="showHomeButton" (click)="home()" (keydown.enter)="home()"  role="button" aria-label="Home">
      <div>
        <button class="voicetext_button_mob" [ngClass]="{'background_highlight':!menuActive}" aria-label="Edit">
          <i class="fa-solid fa-pencil"></i>
        </button>
      </div>
    </div>
    <div (click)="activeTag($event)" *ngIf="updatedmenu && updatedmenu.length"    role="button" aria-label="Images">
      <div>
        <button class="voicetext_button_mob" [ngClass]="{'background_highlight': menuActive && menuActive.id != 16}">
          <i class="fa-solid fa-tag"></i>
        </button>
      </div>
      <div class="l-story-flow-timeline__label d-none d-md-block">
        <!-- {{ storyflowMenu[mediaIndex]?.title }} -->
      </div>
    </div>
    <div (click)="triggerFileInput()" (keydown.enter)="triggerFileInput()"  role="button" aria-label="Camera">
      <div>
        <button class="voicetext_button_mob">
          <i class="fa-solid fa-camera"></i>
        </button>
      </div>
      <input
        type="file"
        #fileInputMob
        style="display: none;"
         accept="video/*,image/png,
                image/jpeg,
                image/jpg,
                image/webp,
                image/gif,
                image/heic,
                image/heif,
                image/bmp,
                image/tiff,
                image/avif"
        (change)="UploadData($event)"
        aria-label="Upload file"
      />
      <div class="l-story-flow-timeline__label d-none d-md-block">
        {{ storyflowMenu[mediaIndex]?.title }}
      </div>
    </div>

    <!-- Media Options -->
    <div (click)="active($event, 16)" (keydown.enter)="active($event, 16)"   role="button" aria-label="Images">
      <div>
        <button class="voicetext_button_mob" [ngClass]="{'background_highlight': menuActive && menuActive.id == 16}">
          <i class="fa-solid fa-images"></i>
        </button>
      </div>
      <div class="l-story-flow-timeline__label d-none d-md-block">
        {{ storyflowMenu[mediaIndex]?.title }}
      </div>
    </div>
    <!--<div (click)="startProceess()" (keydown.enter)="startProceess()"  role="button" aria-label="Microphone">
      <div>
        <button class="voicetext_button_mob">
          <i class="fa-solid fa-microphone" aria-hidden="true"></i>
        </button>
      </div>
      <div class="l-story-flow-timeline__label d-none d-md-block">
        {{ storyflowMenu[mediaIndex]?.title }}
      </div>
    </div>-->


  </div>
</ng-container>
